import * as Yup from "yup";

// Capitaliza cada palabra: "daniel valverde salas" → "Daniel Valverde Salas"
const capitalize = (value) =>
  value
    ? value
        .toLowerCase()
        .replace(/(^|\s)([a-záéíóúñ])/g, (_, space, char) => space + char.toUpperCase())
    : value;

const validationSchema = Yup.object().shape({
  testigo1: Yup.string()
    .required("Nombre del testigo requerido")
    .min(5, "Mínimo 5 caracteres")
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, "Solo se permiten letras y espacios")
    .transform(capitalize),
  testigo2: Yup.string()
    .required("Nombre del testigo requerido")
    .min(5, "Mínimo 5 caracteres")
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, "Solo se permiten letras y espacios")
    .transform(capitalize),
  mensualidades: Yup.number().when("tipocontrato", ([tipocontrato], schema) => {
    return tipocontrato === "credito"
      ? schema
          .required("Indique el número de mensualidades")
          .integer("Debe ser un número entero")
          .min(1, "Mínimo 1 mensualidad")
          .max(120, "Máximo 120 mensualidades (10 años)")
          .typeError("Ingrese un número válido")
      : schema.notRequired();
  }),
  intereses: Yup.number().when("tipocontrato", ([tipocontrato], schema) => {
    return tipocontrato === "credito"
      ? schema
          .required("Seleccione la tasa de interés")
          .min(0, "No puede ser negativo")
          .max(30, "Máximo 30% por políticas de la empresa")
          .typeError("Ingrese un número válido")
      : schema.notRequired();
  }),
  enganche: Yup.number().when("tipocontrato", ([tipocontrato], schema) => {
    return tipocontrato === "credito"
      ? schema
          .required("Indique el monto del enganche")
          .min(0, "No puede ser negativo")
          .typeError("Ingrese un monto válido")
      : schema.notRequired();
  }),
  fechapago: Yup.date()
    .required("Seleccione una fecha")
    .typeError("Fecha no válida")
});

export default validationSchema;
